// app/javascript/application.js
import "@hotwired/turbo-rails"
//import "controllers"
import "./controllers"                // <--- importante ./controllers

import { Application } from "@hotwired/stimulus"
export const application = Application.start()


application.debug = false
window.Stimulus = application

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start() 
